export const cbx_services_links = [
  //{ text: "Servicios CBX+", i18n: "footer.cbx+", to: "/" }, // TODO: Update link
  { text: "Parking service", i18n: "footer.parking", to: "/parking" },
  { text: "Shuttle service", i18n: "footer.shuttle", to: "/cbx-shuttle" },
  { text: "Tickets service", i18n: "footer.tickets", to: "/tickets" },
  { text: "Unatended service", i18n: "footer.unaccompanied", to: "/unaccompanied-teen" },
  { text: "Assisted service", i18n: "footer.assisted", to: "/assisted-pass" },
];

export const documentation_links = [
  { text: "Reglas y regulaciones", i18n: "footer.rules_and_regulations", to: "/rules-regulations" },
  { text: "Requisitos", i18n: "footer.requirements", to: "/requirements" },
  { text: "I-94", i18n: "footer.i94", to: "/I94" },
  { text: "FMM", i18n: "footer.fmm", to: "/fmm" },
];

export const help_links = [
  { text: "Objetos perdidos", i18n: "footer.lost_objects", external: true, to: "https://lostandfoundsoftware.com/lost-item-inquiry.php?id=5185eb05-449f-11e9-802a-062d7f897360" },
  { text: "Preguntas frecuentes", i18n: "footer.frequent_questions", to: "/faq" },
  { text: "Facturación", i18n: "footer.billing", to: "/invoice" },
];

export const info_links = [
  { text: "Blog", i18n: "footer.blog", to: "/experience" },
  { text: "Sobre CBX", i18n: "footer.about_cbx", to: "/about" },
  {
    text: "Conviértete en socio comercial",
    i18n: "footer.become_business_partner",
    to: "/vendor",
  },
  { text: "Anúnciate", i18n: "footer.advertise", external: true, to: "https://crossborderxpress.us16.list-manage.com/subscribe?u=f61760e9a3c753a29663ed242&id=45fbc51bab" },
  { text: "Cómo llegar a CBX", i18n: "footer.how_to_get_to_cbx", to: "/directions" },
  { text: "TCP/Black cars", i18n: "footer.tcp_black_cars", to: "/checkout/tcp-black-cars/" },
];

export const privacy_links = [
  { text: "Política ALPR", i18n: "footer.alpr_policy", to: "/ALPR_policy" },
  { text: "Preferencias de cookies", i18n: "footer.cookie_preferences", to: "/" },
  {
    text: "No vendas o compartas mi información personal",
    i18n: "footer.do_not_sell_my_personal_information",
    to: "/privacy#personalData",
  },
  { text: "Política de privacidad", i18n: "footer.privacy_policy", to: "/privacy" },
];

export const legal_links = [
  { text: "Términos y condiciones", i18n: "footer.terms_and_conditions", to: "/terms" },
  { text: "Reglas y regulaciones", i18n: "footer.rules_and_regulations", to: "/rules-regulations" },
];
